var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewOrderBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.15;}.cls-2,.cls-3{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:0.75px;}.cls-3{stroke-dasharray:4.81 4.81;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 122.78 63.32 125.19 60.91 125.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 125.19,
    x2: 20.03,
    y2: 125.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 125.19 15.22 125.19 15.22 122.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 117.97,
    x2: 15.22,
    y2: 81.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 79.5 15.22 77.09 17.63 77.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 77.09,
    x2: 58.51,
    y2: 77.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 77.09 63.32 77.09 63.32 79.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 84.31,
    x2: 63.32,
    y2: 120.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 122.78 123.36 125.19 120.96 125.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 125.19,
    x2: 80.08,
    y2: 125.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 125.19 75.27 125.19 75.27 122.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 117.97,
    x2: 75.27,
    y2: 81.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 79.5 75.27 77.09 77.67 77.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 77.09,
    x2: 118.55,
    y2: 77.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 77.09 123.36 77.09 123.36 79.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 84.31,
    x2: 123.36,
    y2: 120.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 122.78 183.41 125.19 181 125.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 125.19,
    x2: 140.12,
    y2: 125.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 125.19 135.31 125.19 135.31 122.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 117.97,
    x2: 135.31,
    y2: 81.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 79.5 135.31 77.09 137.72 77.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 77.09,
    x2: 178.6,
    y2: 77.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 77.09 183.41 77.09 183.41 79.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 84.31,
    x2: 183.41,
    y2: 120.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 122.78 243.45 125.19 241.05 125.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 125.19,
    x2: 200.16,
    y2: 125.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 125.19 195.35 125.19 195.35 122.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 117.97,
    x2: 195.35,
    y2: 81.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 79.5 195.35 77.09 197.76 77.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 77.09,
    x2: 238.64,
    y2: 77.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 77.09 243.45 77.09 243.45 79.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 84.31,
    x2: 243.45,
    y2: 120.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 122.78 303.5 125.19 301.09 125.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 125.19,
    x2: 260.21,
    y2: 125.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 125.19 255.4 125.19 255.4 122.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 117.97,
    x2: 255.4,
    y2: 81.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 79.5 255.4 77.09 257.8 77.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 77.09,
    x2: 298.69,
    y2: 77.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 77.09 303.5 77.09 303.5 79.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 84.31,
    x2: 303.5,
    y2: 120.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 123.27 363.92 125.67 361.52 125.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 125.67,
    x2: 320.64,
    y2: 125.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 125.67 315.83 125.67 315.83 123.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 118.46,
    x2: 315.83,
    y2: 82.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 79.98 315.83 77.57 318.23 77.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 77.57,
    x2: 359.11,
    y2: 77.57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 77.57 363.92 77.57 363.92 79.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 84.79,
    x2: 363.92,
    y2: 120.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 123.75 424.35 126.15 421.95 126.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 126.15,
    x2: 381.06,
    y2: 126.15
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 126.15 376.25 126.15 376.25 123.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 118.94,
    x2: 376.25,
    y2: 82.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 80.46 376.25 78.05 378.66 78.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 78.05,
    x2: 419.54,
    y2: 78.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 78.05 424.35 78.05 424.35 80.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 85.27,
    x2: 424.35,
    y2: 121.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 124.23 484.78 126.63 482.38 126.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 126.63,
    x2: 441.49,
    y2: 126.63
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 126.63 436.68 126.63 436.68 124.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 119.42,
    x2: 436.68,
    y2: 83.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 80.94 436.68 78.53 439.09 78.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 78.53,
    x2: 479.97,
    y2: 78.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 78.53 484.78 78.53 484.78 80.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 85.75,
    x2: 484.78,
    y2: 121.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 60.85 63.32 63.25 60.91 63.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 63.25,
    x2: 20.03,
    y2: 63.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 63.25 15.22 63.25 15.22 60.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 56.04,
    x2: 15.22,
    y2: 19.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 17.56 15.22 15.16 17.63 15.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 15.16,
    x2: 58.51,
    y2: 15.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 15.16 63.32 15.16 63.32 17.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 22.37,
    x2: 63.32,
    y2: 58.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 60.85 123.36 63.25 120.96 63.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 63.25,
    x2: 80.08,
    y2: 63.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 63.25 75.27 63.25 75.27 60.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 56.04,
    x2: 75.27,
    y2: 19.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 17.56 75.27 15.16 77.67 15.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 15.16,
    x2: 118.55,
    y2: 15.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 15.16 123.36 15.16 123.36 17.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 22.37,
    x2: 123.36,
    y2: 58.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 60.85 183.41 63.25 181 63.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 63.25,
    x2: 140.12,
    y2: 63.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 63.25 135.31 63.25 135.31 60.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 56.04,
    x2: 135.31,
    y2: 19.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 17.56 135.31 15.16 137.72 15.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 15.16,
    x2: 178.6,
    y2: 15.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 15.16 183.41 15.16 183.41 17.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 22.37,
    x2: 183.41,
    y2: 58.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 60.85 243.45 63.25 241.05 63.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 63.25,
    x2: 200.16,
    y2: 63.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 63.25 195.35 63.25 195.35 60.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 56.04,
    x2: 195.35,
    y2: 19.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 17.56 195.35 15.16 197.76 15.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 15.16,
    x2: 238.64,
    y2: 15.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 15.16 243.45 15.16 243.45 17.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 22.37,
    x2: 243.45,
    y2: 58.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 60.85 303.5 63.25 301.09 63.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 63.25,
    x2: 260.21,
    y2: 63.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 63.25 255.4 63.25 255.4 60.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 56.04,
    x2: 255.4,
    y2: 19.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 17.56 255.4 15.16 257.8 15.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 15.16,
    x2: 298.69,
    y2: 15.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 15.16 303.5 15.16 303.5 17.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 22.37,
    x2: 303.5,
    y2: 58.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 61.33 363.92 63.73 361.52 63.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 63.73,
    x2: 320.64,
    y2: 63.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 63.73 315.83 63.73 315.83 61.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 56.52,
    x2: 315.83,
    y2: 20.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 18.04 315.83 15.64 318.23 15.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 15.64,
    x2: 359.11,
    y2: 15.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 15.64 363.92 15.64 363.92 18.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 22.85,
    x2: 363.92,
    y2: 58.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 61.81 424.35 64.22 421.95 64.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 64.22,
    x2: 381.06,
    y2: 64.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 64.22 376.25 64.22 376.25 61.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 57,
    x2: 376.25,
    y2: 20.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 18.52 376.25 16.12 378.66 16.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 16.12,
    x2: 419.54,
    y2: 16.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 16.12 424.35 16.12 424.35 18.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 23.33,
    x2: 424.35,
    y2: 59.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 62.29 484.78 64.7 482.38 64.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 64.7,
    x2: 441.49,
    y2: 64.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 64.7 436.68 64.7 436.68 62.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 57.48,
    x2: 436.68,
    y2: 21.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 19 436.68 16.6 439.09 16.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 16.6,
    x2: 479.97,
    y2: 16.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 16.6 484.78 16.6 484.78 19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 23.81,
    x2: 484.78,
    y2: 59.89
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 185.2 63.32 187.61 60.91 187.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 187.61,
    x2: 20.03,
    y2: 187.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 187.61 15.22 187.61 15.22 185.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 180.39,
    x2: 15.22,
    y2: 144.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 141.92 15.22 139.51 17.63 139.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 139.51,
    x2: 58.51,
    y2: 139.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 139.51 63.32 139.51 63.32 141.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 146.73,
    x2: 63.32,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 185.2 123.36 187.61 120.96 187.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 187.61,
    x2: 80.08,
    y2: 187.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 187.61 75.27 187.61 75.27 185.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 180.39,
    x2: 75.27,
    y2: 144.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 141.92 75.27 139.51 77.67 139.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 139.51,
    x2: 118.55,
    y2: 139.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 139.51 123.36 139.51 123.36 141.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 146.73,
    x2: 123.36,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 185.2 183.41 187.61 181 187.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 187.61,
    x2: 140.12,
    y2: 187.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 187.61 135.31 187.61 135.31 185.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 180.39,
    x2: 135.31,
    y2: 144.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 141.92 135.31 139.51 137.72 139.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 139.51,
    x2: 178.6,
    y2: 139.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 139.51 183.41 139.51 183.41 141.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 146.73,
    x2: 183.41,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 185.2 243.45 187.61 241.05 187.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 187.61,
    x2: 200.16,
    y2: 187.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 187.61 195.35 187.61 195.35 185.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 180.39,
    x2: 195.35,
    y2: 144.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 141.92 195.35 139.51 197.76 139.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 139.51,
    x2: 238.64,
    y2: 139.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 139.51 243.45 139.51 243.45 141.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 146.73,
    x2: 243.45,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 185.2 303.5 187.61 301.09 187.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 187.61,
    x2: 260.21,
    y2: 187.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 187.61 255.4 187.61 255.4 185.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 180.39,
    x2: 255.4,
    y2: 144.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 141.92 255.4 139.51 257.8 139.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 139.51,
    x2: 298.69,
    y2: 139.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 139.51 303.5 139.51 303.5 141.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 146.73,
    x2: 303.5,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 185.69 363.92 188.09 361.52 188.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 188.09,
    x2: 320.64,
    y2: 188.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 188.09 315.83 188.09 315.83 185.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 180.88,
    x2: 315.83,
    y2: 144.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 142.4 315.83 139.99 318.23 139.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 139.99,
    x2: 359.11,
    y2: 139.99
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 139.99 363.92 139.99 363.92 142.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 147.21,
    x2: 363.92,
    y2: 183.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 186.17 424.35 188.57 421.95 188.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 188.57,
    x2: 381.06,
    y2: 188.57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 188.57 376.25 188.57 376.25 186.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 181.36,
    x2: 376.25,
    y2: 145.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 142.88 376.25 140.47 378.66 140.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 140.47,
    x2: 419.54,
    y2: 140.47
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 140.47 424.35 140.47 424.35 142.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 147.69,
    x2: 424.35,
    y2: 183.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 186.65 484.78 189.05 482.38 189.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 189.05,
    x2: 441.49,
    y2: 189.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 189.05 436.68 189.05 436.68 186.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 181.84,
    x2: 436.68,
    y2: 145.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 143.36 436.68 140.96 439.09 140.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 140.95,
    x2: 479.97,
    y2: 140.95
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 140.96 484.78 140.96 484.78 143.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 148.17,
    x2: 484.78,
    y2: 184.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 247.62 63.32 250.03 60.91 250.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 250.03,
    x2: 20.03,
    y2: 250.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 250.03 15.22 250.03 15.22 247.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 242.81,
    x2: 15.22,
    y2: 206.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 204.34 15.22 201.93 17.63 201.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 201.93,
    x2: 58.51,
    y2: 201.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 201.93 63.32 201.93 63.32 204.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 209.15,
    x2: 63.32,
    y2: 245.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 247.62 123.36 250.03 120.96 250.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 250.03,
    x2: 80.08,
    y2: 250.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 250.03 75.27 250.03 75.27 247.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 242.81,
    x2: 75.27,
    y2: 206.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 204.34 75.27 201.93 77.67 201.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 201.93,
    x2: 118.55,
    y2: 201.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 201.93 123.36 201.93 123.36 204.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 209.15,
    x2: 123.36,
    y2: 245.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 247.62 183.41 250.03 181 250.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 250.03,
    x2: 140.12,
    y2: 250.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 250.03 135.31 250.03 135.31 247.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 242.81,
    x2: 135.31,
    y2: 206.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 204.34 135.31 201.93 137.72 201.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 201.93,
    x2: 178.6,
    y2: 201.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 201.93 183.41 201.93 183.41 204.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 209.15,
    x2: 183.41,
    y2: 245.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 247.62 243.45 250.03 241.05 250.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 250.03,
    x2: 200.16,
    y2: 250.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 250.03 195.35 250.03 195.35 247.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 242.81,
    x2: 195.35,
    y2: 206.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 204.34 195.35 201.93 197.76 201.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 201.93,
    x2: 238.64,
    y2: 201.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 201.93 243.45 201.93 243.45 204.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 209.15,
    x2: 243.45,
    y2: 245.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 247.62 303.5 250.03 301.09 250.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 250.03,
    x2: 260.21,
    y2: 250.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 250.03 255.4 250.03 255.4 247.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 242.81,
    x2: 255.4,
    y2: 206.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 204.34 255.4 201.93 257.8 201.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 201.93,
    x2: 298.69,
    y2: 201.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 201.93 303.5 201.93 303.5 204.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 209.15,
    x2: 303.5,
    y2: 245.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 248.1 363.92 250.51 361.52 250.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 250.51,
    x2: 320.64,
    y2: 250.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 250.51 315.83 250.51 315.83 248.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 243.3,
    x2: 315.83,
    y2: 207.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 204.82 315.83 202.41 318.23 202.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 202.41,
    x2: 359.11,
    y2: 202.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 202.41 363.92 202.41 363.92 204.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 209.63,
    x2: 363.92,
    y2: 245.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 248.59 424.35 250.99 421.95 250.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 250.99,
    x2: 381.06,
    y2: 250.99
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 250.99 376.25 250.99 376.25 248.59"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 243.78,
    x2: 376.25,
    y2: 207.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 205.3 376.25 202.89 378.66 202.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 202.89,
    x2: 419.54,
    y2: 202.89
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 202.89 424.35 202.89 424.35 205.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 210.11,
    x2: 424.35,
    y2: 246.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 249.07 484.78 251.47 482.38 251.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 251.47,
    x2: 441.49,
    y2: 251.47
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 251.47 436.68 251.47 436.68 249.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 244.26,
    x2: 436.68,
    y2: 208.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 205.78 436.68 203.38 439.09 203.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 203.38,
    x2: 479.97,
    y2: 203.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 203.38 484.78 203.38 484.78 205.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 210.59,
    x2: 484.78,
    y2: 246.66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 310.05 63.32 312.45 60.91 312.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 312.45,
    x2: 20.03,
    y2: 312.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 312.45 15.22 312.45 15.22 310.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 305.23,
    x2: 15.22,
    y2: 269.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 266.76 15.22 264.35 17.63 264.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 264.35,
    x2: 58.51,
    y2: 264.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 264.35 63.32 264.35 63.32 266.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 271.57,
    x2: 63.32,
    y2: 307.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 310.05 123.36 312.45 120.96 312.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 312.45,
    x2: 80.08,
    y2: 312.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 312.45 75.27 312.45 75.27 310.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 305.23,
    x2: 75.27,
    y2: 269.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 266.76 75.27 264.35 77.67 264.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 264.35,
    x2: 118.55,
    y2: 264.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 264.35 123.36 264.35 123.36 266.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 271.57,
    x2: 123.36,
    y2: 307.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 310.05 183.41 312.45 181 312.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 312.45,
    x2: 140.12,
    y2: 312.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 312.45 135.31 312.45 135.31 310.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 305.23,
    x2: 135.31,
    y2: 269.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 266.76 135.31 264.35 137.72 264.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 264.35,
    x2: 178.6,
    y2: 264.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 264.35 183.41 264.35 183.41 266.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 271.57,
    x2: 183.41,
    y2: 307.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 310.05 243.45 312.45 241.05 312.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 312.45,
    x2: 200.16,
    y2: 312.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 312.45 195.35 312.45 195.35 310.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 305.23,
    x2: 195.35,
    y2: 269.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 266.76 195.35 264.35 197.76 264.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 264.35,
    x2: 238.64,
    y2: 264.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 264.35 243.45 264.35 243.45 266.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 271.57,
    x2: 243.45,
    y2: 307.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 310.05 303.5 312.45 301.09 312.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 312.45,
    x2: 260.21,
    y2: 312.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 312.45 255.4 312.45 255.4 310.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 305.23,
    x2: 255.4,
    y2: 269.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 266.76 255.4 264.35 257.8 264.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 264.35,
    x2: 298.69,
    y2: 264.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 264.35 303.5 264.35 303.5 266.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 271.57,
    x2: 303.5,
    y2: 307.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 310.53 363.92 312.93 361.52 312.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 312.93,
    x2: 320.64,
    y2: 312.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 312.93 315.83 312.93 315.83 310.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 305.72,
    x2: 315.83,
    y2: 269.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 267.24 315.83 264.83 318.23 264.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 264.83,
    x2: 359.11,
    y2: 264.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 264.83 363.92 264.83 363.92 267.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 272.05,
    x2: 363.92,
    y2: 308.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 311.01 424.35 313.41 421.95 313.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 313.41,
    x2: 381.06,
    y2: 313.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 313.41 376.25 313.41 376.25 311.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 306.2,
    x2: 376.25,
    y2: 270.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 267.72 376.25 265.31 378.66 265.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 265.31,
    x2: 419.54,
    y2: 265.31
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 265.31 424.35 265.31 424.35 267.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 272.53,
    x2: 424.35,
    y2: 308.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 311.49 484.78 313.89 482.38 313.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 313.89,
    x2: 441.49,
    y2: 313.89
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 313.89 436.68 313.89 436.68 311.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 306.68,
    x2: 436.68,
    y2: 270.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 268.2 436.68 265.8 439.09 265.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 265.8,
    x2: 479.97,
    y2: 265.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 265.8 484.78 265.8 484.78 268.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 273.01,
    x2: 484.78,
    y2: 309.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 372.46 63.32 374.87 60.91 374.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 374.87,
    x2: 20.03,
    y2: 374.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 374.87 15.22 374.87 15.22 372.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 367.66,
    x2: 15.22,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 329.18 15.22 326.77 17.63 326.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 326.77,
    x2: 58.51,
    y2: 326.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 326.77 63.32 326.77 63.32 329.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 333.99,
    x2: 63.32,
    y2: 370.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 372.46 123.36 374.87 120.96 374.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 374.87,
    x2: 80.08,
    y2: 374.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 374.87 75.27 374.87 75.27 372.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 367.66,
    x2: 75.27,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 329.18 75.27 326.77 77.67 326.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 326.77,
    x2: 118.55,
    y2: 326.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 326.77 123.36 326.77 123.36 329.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 333.99,
    x2: 123.36,
    y2: 370.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 372.46 183.41 374.87 181 374.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 374.87,
    x2: 140.12,
    y2: 374.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 374.87 135.31 374.87 135.31 372.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 367.66,
    x2: 135.31,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 329.18 135.31 326.77 137.72 326.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 326.77,
    x2: 178.6,
    y2: 326.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 326.77 183.41 326.77 183.41 329.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 333.99,
    x2: 183.41,
    y2: 370.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 372.46 243.45 374.87 241.05 374.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 374.87,
    x2: 200.16,
    y2: 374.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 374.87 195.35 374.87 195.35 372.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 367.66,
    x2: 195.35,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 329.18 195.35 326.77 197.76 326.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 326.77,
    x2: 238.64,
    y2: 326.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 326.77 243.45 326.77 243.45 329.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 333.99,
    x2: 243.45,
    y2: 370.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 372.46 303.5 374.87 301.09 374.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 374.87,
    x2: 260.21,
    y2: 374.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 374.87 255.4 374.87 255.4 372.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 367.66,
    x2: 255.4,
    y2: 331.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 329.18 255.4 326.77 257.8 326.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 326.77,
    x2: 298.69,
    y2: 326.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 326.77 303.5 326.77 303.5 329.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 333.99,
    x2: 303.5,
    y2: 370.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 372.95 363.92 375.35 361.52 375.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 375.35,
    x2: 320.64,
    y2: 375.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 375.35 315.83 375.35 315.83 372.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 368.14,
    x2: 315.83,
    y2: 332.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 329.66 315.83 327.25 318.23 327.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 327.25,
    x2: 359.11,
    y2: 327.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 327.25 363.92 327.25 363.92 329.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 334.47,
    x2: 363.92,
    y2: 370.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 373.43 424.35 375.83 421.95 375.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 375.83,
    x2: 381.06,
    y2: 375.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 375.83 376.25 375.83 376.25 373.43"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 368.62,
    x2: 376.25,
    y2: 332.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 330.14 376.25 327.74 378.66 327.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 327.73,
    x2: 419.54,
    y2: 327.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 327.74 424.35 327.74 424.35 330.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 334.95,
    x2: 424.35,
    y2: 371.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 373.91 484.78 376.31 482.38 376.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 376.31,
    x2: 441.49,
    y2: 376.31
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 376.31 436.68 376.31 436.68 373.91"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 369.1,
    x2: 436.68,
    y2: 333.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 330.62 436.68 328.22 439.09 328.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 328.22,
    x2: 479.97,
    y2: 328.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 328.22 484.78 328.22 484.78 330.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 335.43,
    x2: 484.78,
    y2: 371.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 434.88 63.32 437.29 60.91 437.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 437.29,
    x2: 20.03,
    y2: 437.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 437.29 15.22 437.29 15.22 434.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 430.08,
    x2: 15.22,
    y2: 394
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 391.6 15.22 389.19 17.63 389.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 389.19,
    x2: 58.51,
    y2: 389.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 389.19 63.32 389.19 63.32 391.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 396.41,
    x2: 63.32,
    y2: 432.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 434.88 123.36 437.29 120.96 437.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 437.29,
    x2: 80.08,
    y2: 437.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 437.29 75.27 437.29 75.27 434.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 430.08,
    x2: 75.27,
    y2: 394
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 391.6 75.27 389.19 77.67 389.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 389.19,
    x2: 118.55,
    y2: 389.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 389.19 123.36 389.19 123.36 391.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 396.41,
    x2: 123.36,
    y2: 432.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 434.88 183.41 437.29 181 437.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 437.29,
    x2: 140.12,
    y2: 437.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 437.29 135.31 437.29 135.31 434.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 430.08,
    x2: 135.31,
    y2: 394
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 391.6 135.31 389.19 137.72 389.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 389.19,
    x2: 178.6,
    y2: 389.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 389.19 183.41 389.19 183.41 391.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 396.41,
    x2: 183.41,
    y2: 432.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 434.88 243.45 437.29 241.05 437.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 437.29,
    x2: 200.16,
    y2: 437.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 437.29 195.35 437.29 195.35 434.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 430.08,
    x2: 195.35,
    y2: 394
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 391.6 195.35 389.19 197.76 389.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 389.19,
    x2: 238.64,
    y2: 389.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 389.19 243.45 389.19 243.45 391.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 396.41,
    x2: 243.45,
    y2: 432.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 434.88 303.5 437.29 301.09 437.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 437.29,
    x2: 260.21,
    y2: 437.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 437.29 255.4 437.29 255.4 434.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 430.08,
    x2: 255.4,
    y2: 394
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 391.6 255.4 389.19 257.8 389.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 389.19,
    x2: 298.69,
    y2: 389.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 389.19 303.5 389.19 303.5 391.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 396.41,
    x2: 303.5,
    y2: 432.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 435.37 363.92 437.77 361.52 437.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 437.77,
    x2: 320.64,
    y2: 437.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 437.77 315.83 437.77 315.83 435.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 430.56,
    x2: 315.83,
    y2: 394.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 392.08 315.83 389.67 318.23 389.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 389.67,
    x2: 359.11,
    y2: 389.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 389.67 363.92 389.67 363.92 392.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 396.89,
    x2: 363.92,
    y2: 432.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 435.85 424.35 438.25 421.95 438.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 438.25,
    x2: 381.06,
    y2: 438.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 438.25 376.25 438.25 376.25 435.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 431.04,
    x2: 376.25,
    y2: 394.96
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 392.56 376.25 390.15 378.66 390.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 390.16,
    x2: 419.54,
    y2: 390.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 390.15 424.35 390.15 424.35 392.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 397.37,
    x2: 424.35,
    y2: 433.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 436.33 484.78 438.73 482.38 438.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 438.73,
    x2: 441.49,
    y2: 438.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 438.73 436.68 438.73 436.68 436.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 431.52,
    x2: 436.68,
    y2: 395.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 393.04 436.68 390.64 439.09 390.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 390.64,
    x2: 479.97,
    y2: 390.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 390.64 484.78 390.64 484.78 393.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 397.85,
    x2: 484.78,
    y2: 433.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 497.31 63.32 499.71 60.91 499.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 499.71,
    x2: 20.03,
    y2: 499.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 499.71 15.22 499.71 15.22 497.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 492.5,
    x2: 15.22,
    y2: 456.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 454.02 15.22 451.61 17.63 451.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 451.61,
    x2: 58.51,
    y2: 451.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 451.61 63.32 451.61 63.32 454.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 458.83,
    x2: 63.32,
    y2: 494.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 497.31 123.36 499.71 120.96 499.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 499.71,
    x2: 80.08,
    y2: 499.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 499.71 75.27 499.71 75.27 497.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 492.5,
    x2: 75.27,
    y2: 456.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 454.02 75.27 451.61 77.67 451.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 451.61,
    x2: 118.55,
    y2: 451.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 451.61 123.36 451.61 123.36 454.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 458.83,
    x2: 123.36,
    y2: 494.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 497.31 183.41 499.71 181 499.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 499.71,
    x2: 140.12,
    y2: 499.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 499.71 135.31 499.71 135.31 497.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 492.5,
    x2: 135.31,
    y2: 456.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 454.02 135.31 451.61 137.72 451.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 451.61,
    x2: 178.6,
    y2: 451.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 451.61 183.41 451.61 183.41 454.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 458.83,
    x2: 183.41,
    y2: 494.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 497.31 243.45 499.71 241.05 499.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 499.71,
    x2: 200.16,
    y2: 499.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 499.71 195.35 499.71 195.35 497.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 492.5,
    x2: 195.35,
    y2: 456.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 454.02 195.35 451.61 197.76 451.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 451.61,
    x2: 238.64,
    y2: 451.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 451.61 243.45 451.61 243.45 454.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 458.83,
    x2: 243.45,
    y2: 494.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 497.31 303.5 499.71 301.09 499.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 499.71,
    x2: 260.21,
    y2: 499.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 499.71 255.4 499.71 255.4 497.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 492.5,
    x2: 255.4,
    y2: 456.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 454.02 255.4 451.61 257.8 451.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 451.61,
    x2: 298.69,
    y2: 451.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 451.61 303.5 451.61 303.5 454.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 458.83,
    x2: 303.5,
    y2: 494.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 497.79 363.92 500.19 361.52 500.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 500.19,
    x2: 320.64,
    y2: 500.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 500.19 315.83 500.19 315.83 497.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 492.98,
    x2: 315.83,
    y2: 456.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 454.5 315.83 452.09 318.23 452.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 452.09,
    x2: 359.11,
    y2: 452.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 452.09 363.92 452.09 363.92 454.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 459.31,
    x2: 363.92,
    y2: 495.38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 498.27 424.35 500.67 421.95 500.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 500.67,
    x2: 381.06,
    y2: 500.67
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 500.67 376.25 500.67 376.25 498.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 493.46,
    x2: 376.25,
    y2: 457.39
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 454.98 376.25 452.57 378.66 452.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 452.58,
    x2: 419.54,
    y2: 452.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 452.57 424.35 452.57 424.35 454.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 459.79,
    x2: 424.35,
    y2: 495.86
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 498.75 484.78 501.15 482.38 501.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 501.15,
    x2: 441.49,
    y2: 501.15
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 501.15 436.68 501.15 436.68 498.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 493.94,
    x2: 436.68,
    y2: 457.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 455.46 436.68 453.06 439.09 453.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 453.06,
    x2: 479.97,
    y2: 453.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 453.06 484.78 453.06 484.78 455.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 460.27,
    x2: 484.78,
    y2: 496.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 559.73 63.32 562.13 60.91 562.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 562.13,
    x2: 20.03,
    y2: 562.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 562.13 15.22 562.13 15.22 559.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 554.92,
    x2: 15.22,
    y2: 518.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 516.44 15.22 514.03 17.63 514.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 514.03,
    x2: 58.51,
    y2: 514.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 514.03 63.32 514.03 63.32 516.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 521.25,
    x2: 63.32,
    y2: 557.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 559.73 123.36 562.13 120.96 562.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 562.13,
    x2: 80.08,
    y2: 562.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 562.13 75.27 562.13 75.27 559.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 554.92,
    x2: 75.27,
    y2: 518.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 516.44 75.27 514.03 77.67 514.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 514.03,
    x2: 118.55,
    y2: 514.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 514.03 123.36 514.03 123.36 516.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 521.25,
    x2: 123.36,
    y2: 557.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 559.73 183.41 562.13 181 562.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 562.13,
    x2: 140.12,
    y2: 562.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 562.13 135.31 562.13 135.31 559.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 554.92,
    x2: 135.31,
    y2: 518.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 516.44 135.31 514.03 137.72 514.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 514.03,
    x2: 178.6,
    y2: 514.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 514.03 183.41 514.03 183.41 516.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 521.25,
    x2: 183.41,
    y2: 557.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 559.73 243.45 562.13 241.05 562.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 562.13,
    x2: 200.16,
    y2: 562.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 562.13 195.35 562.13 195.35 559.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 554.92,
    x2: 195.35,
    y2: 518.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 516.44 195.35 514.03 197.76 514.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 514.03,
    x2: 238.64,
    y2: 514.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 514.03 243.45 514.03 243.45 516.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 521.25,
    x2: 243.45,
    y2: 557.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 559.73 303.5 562.13 301.09 562.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 562.13,
    x2: 260.21,
    y2: 562.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 562.13 255.4 562.13 255.4 559.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 554.92,
    x2: 255.4,
    y2: 518.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 516.44 255.4 514.03 257.8 514.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 514.03,
    x2: 298.69,
    y2: 514.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 514.03 303.5 514.03 303.5 516.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 521.25,
    x2: 303.5,
    y2: 557.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 560.21 363.92 562.61 361.52 562.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 562.61,
    x2: 320.64,
    y2: 562.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 562.61 315.83 562.61 315.83 560.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 555.4,
    x2: 315.83,
    y2: 519.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 516.92 315.83 514.51 318.23 514.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 514.51,
    x2: 359.11,
    y2: 514.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 514.51 363.92 514.51 363.92 516.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 521.73,
    x2: 363.92,
    y2: 557.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 560.69 424.35 563.09 421.95 563.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 563.09,
    x2: 381.06,
    y2: 563.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 563.09 376.25 563.09 376.25 560.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 555.88,
    x2: 376.25,
    y2: 519.81
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 517.4 376.25 515 378.66 515"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 515,
    x2: 419.54,
    y2: 515
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 515 424.35 515 424.35 517.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 522.21,
    x2: 424.35,
    y2: 558.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 561.17 484.78 563.57 482.38 563.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 563.57,
    x2: 441.49,
    y2: 563.57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 563.57 436.68 563.57 436.68 561.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 556.36,
    x2: 436.68,
    y2: 520.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 517.88 436.68 515.48 439.09 515.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 515.48,
    x2: 479.97,
    y2: 515.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 515.48 484.78 515.48 484.78 517.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 522.69,
    x2: 484.78,
    y2: 558.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 622.15 63.32 624.55 60.91 624.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 624.55,
    x2: 20.03,
    y2: 624.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 624.55 15.22 624.55 15.22 622.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 617.34,
    x2: 15.22,
    y2: 581.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 578.86 15.22 576.45 17.63 576.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 576.45,
    x2: 58.51,
    y2: 576.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 576.45 63.32 576.45 63.32 578.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 583.67,
    x2: 63.32,
    y2: 619.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 622.15 123.36 624.55 120.96 624.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 624.55,
    x2: 80.08,
    y2: 624.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 624.55 75.27 624.55 75.27 622.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 617.34,
    x2: 75.27,
    y2: 581.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 578.86 75.27 576.45 77.67 576.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 576.45,
    x2: 118.55,
    y2: 576.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 576.45 123.36 576.45 123.36 578.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 583.67,
    x2: 123.36,
    y2: 619.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 622.15 183.41 624.55 181 624.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 624.55,
    x2: 140.12,
    y2: 624.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 624.55 135.31 624.55 135.31 622.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 617.34,
    x2: 135.31,
    y2: 581.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 578.86 135.31 576.45 137.72 576.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 576.45,
    x2: 178.6,
    y2: 576.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 576.45 183.41 576.45 183.41 578.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 583.67,
    x2: 183.41,
    y2: 619.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 622.15 243.45 624.55 241.05 624.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 624.55,
    x2: 200.16,
    y2: 624.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 624.55 195.35 624.55 195.35 622.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 617.34,
    x2: 195.35,
    y2: 581.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 578.86 195.35 576.45 197.76 576.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 576.45,
    x2: 238.64,
    y2: 576.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 576.45 243.45 576.45 243.45 578.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 583.67,
    x2: 243.45,
    y2: 619.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 622.15 303.5 624.55 301.09 624.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 624.55,
    x2: 260.21,
    y2: 624.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 624.55 255.4 624.55 255.4 622.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 617.34,
    x2: 255.4,
    y2: 581.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 578.86 255.4 576.45 257.8 576.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 576.45,
    x2: 298.69,
    y2: 576.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 576.45 303.5 576.45 303.5 578.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 583.67,
    x2: 303.5,
    y2: 619.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 622.63 363.92 625.03 361.52 625.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 625.03,
    x2: 320.64,
    y2: 625.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 625.03 315.83 625.03 315.83 622.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 617.82,
    x2: 315.83,
    y2: 581.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 579.34 315.83 576.93 318.23 576.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 576.94,
    x2: 359.11,
    y2: 576.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 576.93 363.92 576.93 363.92 579.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 584.15,
    x2: 363.92,
    y2: 620.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 623.11 424.35 625.51 421.95 625.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 625.51,
    x2: 381.06,
    y2: 625.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 625.51 376.25 625.51 376.25 623.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 618.3,
    x2: 376.25,
    y2: 582.23
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 579.82 376.25 577.42 378.66 577.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 577.42,
    x2: 419.54,
    y2: 577.42
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 577.42 424.35 577.42 424.35 579.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 584.63,
    x2: 424.35,
    y2: 620.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 623.59 484.78 625.99 482.38 625.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 625.99,
    x2: 441.49,
    y2: 625.99
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 625.99 436.68 625.99 436.68 623.59"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 618.78,
    x2: 436.68,
    y2: 582.71
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 580.3 436.68 577.9 439.09 577.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 577.9,
    x2: 479.97,
    y2: 577.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 577.9 484.78 577.9 484.78 580.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 585.11,
    x2: 484.78,
    y2: 621.18
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 684.57 63.32 686.97 60.91 686.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 686.97,
    x2: 20.03,
    y2: 686.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 686.97 15.22 686.97 15.22 684.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 679.76,
    x2: 15.22,
    y2: 643.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 641.28 15.22 638.87 17.63 638.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 638.87,
    x2: 58.51,
    y2: 638.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 638.87 63.32 638.87 63.32 641.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 646.09,
    x2: 63.32,
    y2: 682.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 684.57 123.36 686.97 120.96 686.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 686.97,
    x2: 80.08,
    y2: 686.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 686.97 75.27 686.97 75.27 684.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 679.76,
    x2: 75.27,
    y2: 643.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 641.28 75.27 638.87 77.67 638.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 638.87,
    x2: 118.55,
    y2: 638.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 638.87 123.36 638.87 123.36 641.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 646.09,
    x2: 123.36,
    y2: 682.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 684.57 183.41 686.97 181 686.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 686.97,
    x2: 140.12,
    y2: 686.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 686.97 135.31 686.97 135.31 684.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 679.76,
    x2: 135.31,
    y2: 643.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 641.28 135.31 638.87 137.72 638.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 638.87,
    x2: 178.6,
    y2: 638.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 638.87 183.41 638.87 183.41 641.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 646.09,
    x2: 183.41,
    y2: 682.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 684.57 243.45 686.97 241.05 686.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 686.97,
    x2: 200.16,
    y2: 686.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 686.97 195.35 686.97 195.35 684.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 679.76,
    x2: 195.35,
    y2: 643.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 641.28 195.35 638.87 197.76 638.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 638.87,
    x2: 238.64,
    y2: 638.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 638.87 243.45 638.87 243.45 641.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 646.09,
    x2: 243.45,
    y2: 682.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 684.57 303.5 686.97 301.09 686.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 686.97,
    x2: 260.21,
    y2: 686.97
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 686.97 255.4 686.97 255.4 684.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 679.76,
    x2: 255.4,
    y2: 643.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 641.28 255.4 638.87 257.8 638.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 638.87,
    x2: 298.69,
    y2: 638.87
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 638.87 303.5 638.87 303.5 641.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 646.09,
    x2: 303.5,
    y2: 682.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 685.05 363.92 687.45 361.52 687.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 687.45,
    x2: 320.64,
    y2: 687.45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 687.45 315.83 687.45 315.83 685.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 680.24,
    x2: 315.83,
    y2: 644.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 641.76 315.83 639.36 318.23 639.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 639.36,
    x2: 359.11,
    y2: 639.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 639.36 363.92 639.36 363.92 641.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 646.57,
    x2: 363.92,
    y2: 682.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 685.53 424.35 687.93 421.95 687.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 687.93,
    x2: 381.06,
    y2: 687.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 687.93 376.25 687.93 376.25 685.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 680.72,
    x2: 376.25,
    y2: 644.65
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 642.24 376.25 639.84 378.66 639.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 639.84,
    x2: 419.54,
    y2: 639.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 639.84 424.35 639.84 424.35 642.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 647.05,
    x2: 424.35,
    y2: 683.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 686.01 484.78 688.41 482.38 688.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 688.41,
    x2: 441.49,
    y2: 688.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 688.41 436.68 688.41 436.68 686.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 681.2,
    x2: 436.68,
    y2: 645.13
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 642.72 436.68 640.32 439.09 640.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 640.32,
    x2: 479.97,
    y2: 640.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 640.32 484.78 640.32 484.78 642.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 647.53,
    x2: 484.78,
    y2: 683.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.32 746 63.32 748.4 60.91 748.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.1,
    y1: 748.4,
    x2: 20.03,
    y2: 748.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.63 748.4 15.22 748.4 15.22 746"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 15.22,
    y1: 741.19,
    x2: 15.22,
    y2: 705.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.22 702.71 15.22 700.3 17.63 700.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.44,
    y1: 700.3,
    x2: 58.51,
    y2: 700.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "60.91 700.3 63.32 700.3 63.32 702.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.32,
    y1: 707.52,
    x2: 63.32,
    y2: 743.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.36 746 123.36 748.4 120.96 748.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.15,
    y1: 748.4,
    x2: 80.08,
    y2: 748.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.67 748.4 75.27 748.4 75.27 746"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.27,
    y1: 741.19,
    x2: 75.27,
    y2: 705.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "75.27 702.71 75.27 700.3 77.67 700.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 82.48,
    y1: 700.3,
    x2: 118.55,
    y2: 700.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "120.96 700.3 123.36 700.3 123.36 702.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.36,
    y1: 707.52,
    x2: 123.36,
    y2: 743.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "183.41 746 183.41 748.4 181 748.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.19,
    y1: 748.4,
    x2: 140.12,
    y2: 748.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "137.72 748.4 135.31 748.4 135.31 746"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.31,
    y1: 741.19,
    x2: 135.31,
    y2: 705.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "135.31 702.71 135.31 700.3 137.72 700.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 142.52,
    y1: 700.3,
    x2: 178.6,
    y2: 700.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "181 700.3 183.41 700.3 183.41 702.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 183.41,
    y1: 707.52,
    x2: 183.41,
    y2: 743.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.45 746 243.45 748.4 241.05 748.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.24,
    y1: 748.4,
    x2: 200.16,
    y2: 748.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "197.76 748.4 195.35 748.4 195.35 746"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195.35,
    y1: 741.19,
    x2: 195.35,
    y2: 705.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "195.35 702.71 195.35 700.3 197.76 700.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 202.57,
    y1: 700.3,
    x2: 238.64,
    y2: 700.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.05 700.3 243.45 700.3 243.45 702.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 243.45,
    y1: 707.52,
    x2: 243.45,
    y2: 743.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "303.5 746 303.5 748.4 301.09 748.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 296.28,
    y1: 748.4,
    x2: 260.21,
    y2: 748.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "257.8 748.4 255.4 748.4 255.4 746"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.4,
    y1: 741.19,
    x2: 255.4,
    y2: 705.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.4 702.71 255.4 700.3 257.8 700.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 262.61,
    y1: 700.3,
    x2: 298.69,
    y2: 700.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.09 700.3 303.5 700.3 303.5 702.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.5,
    y1: 707.52,
    x2: 303.5,
    y2: 743.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "363.92 746.48 363.92 748.88 361.52 748.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 356.71,
    y1: 748.88,
    x2: 320.64,
    y2: 748.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "318.23 748.88 315.83 748.88 315.83 746.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 315.83,
    y1: 741.67,
    x2: 315.83,
    y2: 705.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.83 703.19 315.83 700.78 318.23 700.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 323.04,
    y1: 700.78,
    x2: 359.11,
    y2: 700.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "361.52 700.78 363.92 700.78 363.92 703.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 363.92,
    y1: 708,
    x2: 363.92,
    y2: 744.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "424.35 746.96 424.35 749.36 421.95 749.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 417.14,
    y1: 749.36,
    x2: 381.06,
    y2: 749.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "378.66 749.36 376.25 749.36 376.25 746.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.25,
    y1: 742.15,
    x2: 376.25,
    y2: 706.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "376.25 703.67 376.25 701.27 378.66 701.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 383.47,
    y1: 701.27,
    x2: 419.54,
    y2: 701.27
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "421.95 701.27 424.35 701.27 424.35 703.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 424.35,
    y1: 708.48,
    x2: 424.35,
    y2: 744.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "484.78 747.44 484.78 749.84 482.38 749.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 477.56,
    y1: 749.84,
    x2: 441.49,
    y2: 749.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "439.09 749.84 436.68 749.84 436.68 747.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 436.68,
    y1: 742.63,
    x2: 436.68,
    y2: 706.56
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.68 704.15 436.68 701.75 439.09 701.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.9,
    y1: 701.75,
    x2: 479.97,
    y2: 701.75
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "482.38 701.75 484.78 701.75 484.78 704.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.78,
    y1: 708.96,
    x2: 484.78,
    y2: 745.03
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewOrderBg);
export default __webpack_public_path__ + "static/media/preview-order-bg.7e6648199b1e720c5b2eb88e869857e6.svg";
export { ForwardRef as ReactComponent };